import { Sorter } from '../../../ts/services/SorterFactory';

interface SorterScope extends ng.IScope {
  sorter: Sorter;
}

export function detachSorterOnPathChange(
  $scope: SorterScope,
  $location: ng.ILocationService,
  shouldDetach: () => boolean
) {
  $scope.$watch(() => $location.url(), () => {
    if (shouldDetach()) {
      $scope.sorter.detach();
    }
  });
}
